/** @format */

import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@mui/styles';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';

const useStyles = makeStyles(theme => ({
  formControl: {
    width: '100%',
    minWidth: 120,
    borderBottom: '2px solid black',
    '&:has(.Mui-error)': {
      borderColor: '#f44336'
    },
    '& > label': {
      fontSize: 18,
      color: 'black'
    },
    '& .MuiFormLabel-root.Mui-focused': {
      color: 'black'
    }
  },
  selectEmpty: {
    marginTop: theme.spacing(2)
  },
  select: {
    color: '#000',
    textAlign: 'left',
    fontSize: 18,
    '&:after': {
      position: 'absolute',
      top: '50%',
      right: 0,
      left: 'auto',
      bottom: 'auto',
      transform: 'translate(0, -50%)!important',
      width: 22,
      height: 22,
      background: `${theme.palette.primary.main} url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="8" height="6" viewBox="0 0 8 6" fill="none"><path d="M7.06 0.530029L4 3.58336L0.94 0.530029L0 1.47003L4 5.47003L8 1.47003L7.06 0.530029Z" fill="black"/></svg>') center center no-repeat`,
      border: 0,
      borderRadius: 100
    }
  }
}));

type SelectOption = {
  value?: string;
  name?: string;
};

type SelectComponentProps = {
  label?: string;
  value?: string;
  error?: boolean;
  onChange?: (event: SelectChangeEvent<string>) => void;
  options?: SelectOption[];
};

const SelectComponent = (props: SelectComponentProps) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [value, setValue] = useState('');

  const handleChange = (event: SelectChangeEvent<string>) => {
    setValue(String(event.target.value));
    if (props.onChange) {
      props.onChange(event);
    }
  };

  useEffect(() => {
    setValue(props.value || '');
  }, [props.value]);

  return (
    <>
      <FormControl className={classes.formControl} error={props.error}>
        <InputLabel>{props?.label}</InputLabel>
        <Select error={props.error} className={classes.select} value={props.value || value} onChange={handleChange}>
          <MenuItem value="">
            <em>{t('common.none')}</em>
          </MenuItem>
          {props?.options?.map(item => (
            <MenuItem value={item?.value || item?.name} key={item?.value || item?.name}>
              {item?.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </>
  );
};

export default SelectComponent;
